module.exports = __webpack_public_path__ + "img/logo_bep.afcae93b.png";